export enum COOKIE {
  CB = "cb",
  SESSION_START = "o_squirrel_sessionStart",
  SESSION_START_SENDED = "o_squirrel_sessionStart_sended",
}

export enum COOKIE_BANNER {
  DISABLED = "0",
  ENABLED = "1",
  IGNORED = "2",
}
